import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import intercom from "../images/Intercom photo.jpg";
import talkintercom from "../images/Talk Intercomsystem.jpg";
import line2TalkIntercom from "../images/2 Line Intercom.jpg";
import Wirelessintercom from "../images/Wireless Intercom.jpg";
import intercomsystem from "../images/Intercom Sytem.jpg"



function Intercom() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Intercom System</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
       <div className='computershopberhampore'>
           <br />
      <div className="album py-1">

        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={talkintercom} className="card-img-top" alt="talkintercom" />
                <div className='card-body'>
                  <h5 style={{color:"darkblue"}} className='mb-1'><b>Talk Intercom</b></h5>
                  <p className='mb-0'>Best Brand Talk Intercom Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={line2TalkIntercom} className="card-img-top" alt="line2TalkIntercom" />
                <div className='card-body'>
               <h5 style={{color:"darkblue"}} className='mb-1'><b> 2 Line Talk Intercom</b></h5>
                  <p className='mb-0'>Best Brand Talk Intercom Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={Wirelessintercom} className="card-img-top" alt="Wirelessintercom"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>Wireless Intercom</b></h5>
                  <p className='mb-0'>Best Brand Wireless Intercom Available</p>
                </div>
              </div>
            </div>

             <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={intercomsystem} className="card-img-top" alt="intercomsystem"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>Intercom System</b></h5>
                  <p className='mb-0'>Best Brand Intercom System Available</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
         <br />
         <br/>
      </div>
      <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{color:"#030D54"}}> <b>Intercom System</b></h1>
              <hr />
              <p className='justify'>Our Intercom System provides secure, clear, and instant communication between rooms, floors, and entry points. Designed for homes, offices, shops, apartments, and commercial buildings, it enhances safety with audio/video calling, door access control, and visitor verification. Easy to install, user-friendly, and built for long-term reliability.</p>
              <br />
              
               <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
               <br/>
               <br/>
            </div>
            <div className="col-md-4">
                    <img src={intercom} className="d-block w-100" alt="Intercom System"/>

            </div>
          </div>

        </div>
      </div>



    </div>
  )
}

export default Intercom